(function ($) {
  multiProdSkuRowV1 = {
    formatter: $('.multi-prod-sku-row-v1')
  };

  Drupal.behaviors.multiProdSkuRowV1 = {
    get: function (key) {
      return multiProdSkuRowV1[key];
    },

    set: function (key, val) {
      multiProdSkuRowV1[key] = val;
    },

    attach: function () {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        // Get parent formatter
        var parentFormatter = thisFormatter.closest('.multi-prod-sku-row-formatter-v1');
        var prodDiv = parentFormatter.find('.product');
        var activeProdDiv = parentFormatter.find('.product.active');

        prodDiv.each(function (i) {
          var self = $(this);

          self.attr('data-item', i + 1);
        });

        // Set shade-box data-item
        var dataItem = thisFormatter.closest('.shades').find('.col2 .slides .shade-box');

        dataItem.each(function (i) {
       	var item = $(this);

       	item.attr('data-item', i + 1);
        });

        // Set defaultDataItem value 
        // grab this from the first shade in the list of slides, not necessarily the first review in the reviews container
        var defaultDataItem = thisFormatter.closest('.shades').find('.col2 .slides .shade-box:first').data('item');
        // Get shades and slider skubaseid
        var dataSkuBaseId = thisFormatter.data('skubaseid');
        var sliderDataSkuBaseId = thisFormatter.closest('.shades').find('.col2 .slides .shade-box').data('skubaseid');

        // Make matched parent formatter visible
        prodDiv.filter(function () {
          var self = $(this);

          return self.attr('data-item') == defaultDataItem;
        }).removeClass('hidden').addClass('active');

        // Make shade review #4 default shade review
        thisFormatter.find('.manual-reviews').find('.manual-review').filter(function () {
          var self = $(this);

          return dataSkuBaseId == sliderDataSkuBaseId;
        }).fadeIn('slow');

        // Show shade box #4
        thisFormatter.find('.manual-reviews').find('.wrapper').filter(function () {
          var self = $(this);

          return dataSkuBaseId == sliderDataSkuBaseId;
        }).removeClass('hidden').addClass('active');

        // Set default swoosh bg color
        var defaultShadeColor = parentFormatter.find('.product.active').attr('data-skushade');

        thisFormatter
          .find('.shade-dd-menu .col1 .smoosh-wrapper')
          .css({ 'background-color': defaultShadeColor });

        // Set product title bg color
        thisFormatter
          .find('.manual-reviews .product-title')
          .fadeIn('slow')
          .css({ 'color': defaultShadeColor });

        // Set add-to-bag button bg color  
        thisFormatter.find('.manual-reviews').find('.wrapper').find('.button.add-to-bag').filter(function () {
          var self = $(this);

          return dataSkuBaseId == sliderDataSkuBaseId;
        }).css({ 'background-color': defaultShadeColor });

        // grab the price box from the "main" SPP controls (gotta wait for the site.spp.init function to run)
        $(document).one('site.spp.init.finished', function () { // to make sure that this only fires once, EVEN if the spp.init.finished event fires twice or more
          thisFormatter.find('.add-to-bag.button').each(function () {
            var button = $(this),
              skuBaseId = button.attr('data-skubaseid'),
              matchedSkus = $(site.spp.data.product.skus).filter(function () { // pulled from clinique_product_spp_v1.js
                return this.SKU_BASE_ID.toString() === skuBaseId;
              }),
              matchedSku;

            if (matchedSkus) {
              if (matchedSkus.length === 1) {
                matchedSku = matchedSkus[0];
              } else if (matchedSkus.length > 1) {
                throw new Error('Too many skus were matched for this shade, for what-people-are-saying-v1, in its init process');
              } else {
                throw new Error('No skus were matched for this shade, for what-people-are-saying-v1, in its init process');
              }
            } else {
              throw new Error('The sku find method failed abnormally, for what-people-are-saying-v1, in its init process');
            }

            $('.module-spp-detail .options .price')
              .clone()
              .insertBefore(button)
              .find('.formatted_price')
              .text(matchedSku.formattedPrice);
          });
        });
      });

      // Add to Bag
      $('.add-to-bag.button', formatter).once('multi-prod-sku-row-v1-init-add-to-bag').on('click', function(e) {
        e.preventDefault();
        // Set loading icon
        var loadingId = site.loading.show({
          'target': e.target,
          'matchTarget': ['display', 'height', 'width'],
          'css': {
            'text-align': 'center',
            'vertical-align': 'top'
          }
        });
        // get sku for 'add to cart'
        var buySkus = [];

        buySkus = $(this).attr('data-skubaseid');
        // add sku to cart
        site.addToCart({
          skuBaseId: buySkus
        });
        // Show loading icon
        $(document).one('addToCart.success addToCart.failure', function () {
          site.loading.hide(loadingId);
        });
      });
    }
  };
})(jQuery);
